import { MDBCol, MDBInput, MDBRow } from "mdb-react-ui-kit";
import React from "react";
import { validatePhoneNumber } from "../../phonenumbers/AddRemoveNumbers";

function BrandContactDetails({ register, watch, errors, setValue }) {
  return (
    <>
      <div className="mt-3">
        <h5 className="my-3 p-3 bg-light-200">Contact Details:</h5>
      </div>
      <div className="pb-2">
        <MDBRow className="my-1">
          <MDBCol size={6}>
            <div className="tel-numbers">
              <strong>Name</strong>
            </div>
            <div className="d-flex">
              <MDBInput
                type="text"
                {...register("contact_details.contact_name")}
              />
              {errors?.contact_details?.contact_name && (
                <p className="text-danger">
                  {errors?.contact_details?.contact_name?.message}
                </p>
              )}
            </div>
          </MDBCol>
          <MDBCol size={6}>
            <div className="tel-numbers">
              <strong>Phone *</strong>
            </div>
            <div className="d-flex">
              <MDBInput
                type="text"
                {...register("contact_details.phno", {
                  required: "Phone Number is required",
                  validate: validatePhoneNumber
                })}
              />
              {errors?.contact_details?.phno && (
                <p className="text-danger">
                  {errors?.contact_details?.phno?.message}
                </p>
              )}
            </div>
          </MDBCol>
        </MDBRow>

        <MDBRow>
          <MDBCol size={6}>
            <div className="tel-numbers">
              <strong>Email *</strong>
            </div>
            <div className="d-flex">
              <MDBInput
                type="text"
                {...register("contact_details.email", {
                  setValueAs: (v) => v?.trim(), 
                  required: "Email is required",
                  pattern: {
                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                    message: "Invalid Email",
                  },
                })}
              />
              {errors?.contact_details?.email && (
                <p className="text-danger">
                  {errors?.contact_details?.email?.message}
                </p>
              )}
            </div>
          </MDBCol>
        </MDBRow>
      </div>
    </>
  );
}

export default BrandContactDetails;
